import React from "react";
import CartSingleProduct from "./CartSingleProduct";
import TotalProduct from "./TotalProduct";
import { useSelector } from "react-redux";

const CartProducts = () => {
  const cart = useSelector((state) => state.cart);
  const totalProduct = cart.reduce((total, current) => total + current.addedItem, 0);
  return (
    <div className='bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4'>
      {cart &&
        cart.map((singleProduct) => <CartSingleProduct productDetails={singleProduct} key={singleProduct.productId} />)}
      <TotalProduct totalProduct={totalProduct} />
    </div>
  );
};

export default CartProducts;
